import ProductColorCard from "./ProductColorCard";

export default ProductColorCard;
